import { catalogFor } from './catalogs';
import { en, type MessageKey } from './en';
import type { LocaleId } from './locales';

export type TranslateVars = Record<string, string | number>;

function fill(text: string, vars?: TranslateVars): string {
  if (!vars) return text;
  return Object.keys(vars).reduce(
    (current, key) => current.split(`{${key}}`).join(String(vars[key])),
    text
  );
}

function toBritish(text: string): string {
  return text
    .replace(/Colors/g, 'Colours')
    .replace(/colors/g, 'colours')
    .replace(/Color/g, 'Colour')
    .replace(/color/g, 'colour');
}

export function translate(locale: LocaleId, key: MessageKey, vars?: TranslateVars): string {
  const specific = catalogFor(locale)[key];
  if (specific) return fill(specific, vars);
  const english = locale === 'en-GB' ? toBritish(en[key]) : en[key];
  return fill(english, vars);
}
